import '../App.js';
import Post from './Post';
import React, { useState } from 'react';
import { useEffect } from 'react';
import axios from '../apis/Axios';

function Posts({ onLoaded }) {
    const [posts, setPosts] = React.useState([]);   
    
    useEffect(() => {
        const getPostData = async () => {          
            try { 
                const res = await axios.get('api/Post');
                setPosts(res.data);
                onLoaded?.();
            } catch (err) {
                console.log(err);
            }
        }
        
        getPostData();
    }, [onLoaded]);

    return (
        <div class='posts'>
            {
                posts.map((post, index) => {
                    const date = new Date(post.creationDate);
                    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
                    return (
                        <Post
                            title = { post.title }
                            creationDate = { formattedDate }
                            author = { post.author }
                            description = { post.description }
                            link = { 'blog/' + post.id }
                            tags = { post.tags }
                            postIndex = { index }
                        />
                    );
                })
            }
        </div>
    )
};

export default Posts;